import type { DataOption } from '@/common.types'

import { map, paths, pipe } from 'lodash/fp'

import { useOptimizationGroupsQuery } from '@/entities/optimization-group'

import { toOption } from '@/shared/tools/utils'

export const useOptimizationGroupsOptions = (options?: {
	enabled?: boolean
}) => {
	const {
		data: optimizationGroupsOptions,
		isLoading,
		isError,
	} = useOptimizationGroupsQuery<DataOption[]>({
		select: pipe(map(paths(['id', 'name'])), toOption),
		...(options ?? {}),
	})

	return {
		optimizationGroupsOptions: optimizationGroupsOptions || [],
		isLoading,
		isError,
	}
}
